export default {
  enums: [
    { id: 'DOC' },
    { id: 'OUT' },
    { id: 'INPUT' },
    { id: 'AGGR' },
    { id: 'REMARK' },
    { id: 'UPD' },
    {id: 'REPORT'},
    {id: 'ATK'}
    // { id: 'ORDER'},
  ],
};
